function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { ShoppingGallery } from "./shopping-gallery";
//import { FiltersHeader } from "./filters-header";
import FiltersBar from "./filters-bar";
import SortBar from "./sort-bar";
import ChairsFiltersBar from "./chairs-filters-bar";
import CollectionFiltersBar from "./collection-filters-bar";
import { cloneData } from "../../../library/utils/clone";
import { sortByProperty } from "../../functions/sort-by-property";
class Gallery extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let data = this.props.data;
    let count = data.length;
    let countLabel = count === 1 ? "item" : "items";
    return /*#__PURE__*/React.createElement("div", {
      className: "gallery-grid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gallery-filters-container"
    }), /*#__PURE__*/React.createElement("div", {
      className: "gallery-items-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "filters-header-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "filters-bar-small-screen"
    }, /*#__PURE__*/React.createElement("span", null, "Filter & Sort")), /*#__PURE__*/React.createElement("div", {
      className: "filters-bar-container"
    }, this.props.children), /*#__PURE__*/React.createElement("div", {
      className: "gallery-items-count"
    }, /*#__PURE__*/React.createElement(SortBar, {
      onSortChange: this.props.onSortChange
    }), /*#__PURE__*/React.createElement("span", {
      className: "count-label"
    }, count, " ", countLabel))), /*#__PURE__*/React.createElement("div", {
      className: "gallery-items-list"
    }, /*#__PURE__*/React.createElement(ShoppingGallery, {
      data: this.props.data,
      baseImageUrl: this.props.baseImageUrl,
      onLike: this.props.onLike
    }), count < 1 && /*#__PURE__*/React.createElement("div", {
      className: "gallery-no-results"
    }, "No items match your filter criteria. Please adjust your filters and try again."))));
  }
}
class BaseGalleryComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onFiltersChange", filters => {
      let arr = this.state.dataCopy;
      let newData = [];
      console.log("Filters changed:", filters);
      let numberFilters = 0;
      // let numberFilters=filters.features.length + filters.quick.length + filters.collections.length + filters.armHeights.length + filters.heights.length + filters.widths.length + filters.depths.length + filters.products.length;
      Object.keys(filters).forEach(key => {
        if (key !== 'showMoreFilters') numberFilters += filters[key].length;
      });
      console.log("Number of active filters:", numberFilters);
      if (numberFilters == 0) {
        this.setState({
          data: arr
        });
      } else if (numberFilters == 1) {
        newData = this.getRandomSubset(arr, 18);
        this.setState({
          data: newData
        });
      } else if (numberFilters == 2) {
        newData = this.getRandomSubset(arr, 12);
        this.setState({
          data: newData
        });
      } else if (numberFilters == 3) {
        newData = this.getRandomSubset(arr, 9);
        this.setState({
          data: newData
        });
      } else if (numberFilters == 4) {
        newData = this.getRandomSubset(arr, 6);
        this.setState({
          data: newData
        });
      } else if (numberFilters == 5) {
        newData = this.getRandomSubset(arr, 2);
        this.setState({
          data: newData
        });
      } else if (numberFilters > 5) {
        newData = this.getRandomSubset(arr, 1);
        this.setState({
          data: newData
        });
      }
    });
    _defineProperty(this, "onLike", item => {
      console.log("Liked item:", item);
      this.toast.show('Item added to your favorites!');
    });
    _defineProperty(this, "onSortChange", sortBy => {
      console.log("Sort changed:", sortBy);
      // Implement sorting logic here based on sortBy value
      // For example, you might want to sort this.state.dataCopy and then update this.state.data
      let params = sortBy.split("|");
      let sortField = params[0];
      let sortDirection = params[1];
      let sortedData = sortByProperty(this.state.dataCopy, sortField, sortDirection);
      this.setState({
        data: sortedData
      });
    });
    let data = props.data || [];
    this.state = {
      data: data,
      dataCopy: cloneData(data)
    };
  }
  componentDidMount() {
    this.toast = document.querySelector("paper-toast");
  }
  getRandomSubset(arr, n) {
    // Make a shallow copy so we don't mutate the original array
    const copy = arr.slice();

    // If we ask for more items than exist, return everything shuffled
    if (n >= copy.length) {
      // Shuffle the whole copy and return it
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }

    // We only need to shuffle the first `n` items
    for (let i = copy.length - 1; i > copy.length - 1 - n; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }

    // Return the last `n` items (they are now randomized)
    return copy.slice(-n);
  }
}
export class GalleryComponent extends BaseGalleryComponent {
  render() {
    return /*#__PURE__*/React.createElement(Gallery, {
      data: this.state.data,
      onFiltersChange: this.onFiltersChange,
      baseImageUrl: this.props.baseImageUrl,
      onLike: this.onLike,
      onSortChange: this.onSortChange
    }, /*#__PURE__*/React.createElement(FiltersBar, {
      onFiltersChange: this.onFiltersChange
    }));
  }
}
export class ChairsGalleryComponent extends BaseGalleryComponent {
  render() {
    return /*#__PURE__*/React.createElement(Gallery, {
      data: this.state.data,
      onFiltersChange: this.onFiltersChange,
      baseImageUrl: this.props.baseImageUrl,
      onLike: this.onLike,
      onSortChange: this.onSortChange
    }, /*#__PURE__*/React.createElement(ChairsFiltersBar, {
      onFiltersChange: this.onFiltersChange
    }));
  }
}
export class CollectionGalleryComponent extends BaseGalleryComponent {
  render() {
    return /*#__PURE__*/React.createElement(Gallery, {
      data: this.state.data,
      onFiltersChange: this.onFiltersChange,
      baseImageUrl: this.props.baseImageUrl,
      onLike: this.onLike,
      onSortChange: this.onSortChange
    }, /*#__PURE__*/React.createElement(CollectionFiltersBar, {
      onFiltersChange: this.onFiltersChange
    }));
  }
}